import { render, staticRenderFns } from "./bgys-asset-group-category-asset-group-view.vue?vue&type=template&id=3d67428e&scoped=true"
import script from "./bgys-asset-group-category-asset-group-view.vue?vue&type=script&lang=js"
export * from "./bgys-asset-group-category-asset-group-view.vue?vue&type=script&lang=js"
import style0 from "./bgys-asset-group-category-asset-group-view.vue?vue&type=style&index=0&id=3d67428e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d67428e",
  null
  
)

export default component.exports